import { Stack } from '@mui/material';
import { WandLoader, type WandLoaderSize } from '@opengov/components-wand-loader';

/**
 * Shared size for all pre-Layout / no-nav full-page wand loaders.
 * Change once here to update auth, token, and entity boot screens together.
 */
export const FULL_PAGE_WAND_LOADER_SIZE: WandLoaderSize = 'large';

interface FullPageWandLoaderProps {
  /** Optional label shown beside/under the wand (passed through to WandLoader). */
  label?: string;
}

/**
 * Full-viewport centered WandLoader for boot states where Layout/nav is not
 * yet visible (auth gate, waiting for token, entity QueryBoundary).
 */
export function FullPageWandLoader({ label }: FullPageWandLoaderProps) {
  return (
    <Stack alignItems="center" justifyContent="center" sx={{ width: '100%', height: '100vh' }}>
      <WandLoader size={FULL_PAGE_WAND_LOADER_SIZE} label={label} />
    </Stack>
  );
}
